var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("base-dialog", {
        attrs: {
          content: _vm.$t("tests.work-environment.confidentialityWarning"),
          okFn: function async() {
            _vm.confidentialityDialog.visible = false
          },
          cancelFn: function() {
            _vm.back()
          },
          dontShowAgainCookie: _vm.confidentialityDialog.cookie
        },
        model: {
          value: _vm.confidentialityDialog.visible,
          callback: function($$v) {
            _vm.$set(_vm.confidentialityDialog, "visible", $$v)
          },
          expression: "confidentialityDialog.visible"
        }
      }),
      _vm._v(" "),
      _c("test-template", {
        attrs: {
          testName: _vm.testName,
          testId: _vm.testId,
          test: _vm.test,
          multidimensional: ""
        },
        on: { setFinishedMessageResultsHidden: _vm.setMessage },
        scopedSlots: _vm._u([
          {
            key: "questions",
            fn: function() {
              return [
                _c("question-card", {
                  attrs: {
                    question: _vm.cQ,
                    progress: _vm.$store.state.tests.currentSlide,
                    questionnaireLength: _vm.$store.state.tests.test.length
                  },
                  on: {
                    answerQuestion: function() {
                      _vm.$store.commit("tests/incrementSlide")
                    },
                    submitQuestionnaire: _vm.saveTestResults
                  },
                  model: {
                    value: _vm.questionResult,
                    callback: function($$v) {
                      _vm.questionResult = $$v
                    },
                    expression: "questionResult"
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "results",
            fn: function() {
              return [
                _vm.$store.getters["session/userIsPatient"]
                  ? _c(
                      "b-row",
                      {
                        staticClass: "slidesSize",
                        attrs: { "align-v": "center" }
                      },
                      [
                        _c("loading-anim", {
                          attrs: {
                            active: _vm.$store.state.loading,
                            fullScreen: ""
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            staticClass:
                              "px-0 pt-1 px-md-5 pt-md-2 m-auto align-middle"
                          },
                          [
                            _c("h3", [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.$t("tests.hello")) +
                                    " " +
                                    _vm._s(_vm.$store.state.session.user.name) +
                                    ","
                                )
                              ])
                            ]),
                            _c("br"),
                            _vm._v(" "),
                            _c("h5", {
                              domProps: {
                                innerHTML: _vm._s(_vm.testFinishedMessage)
                              }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.getters["session/userIsProfessional"]
                  ? _c("div", [
                      _c(
                        "div",
                        { key: "recapCard", staticClass: "second" },
                        [
                          _c("h4", [
                            _vm._v(
                              _vm._s(_vm.$t("tests.results")) +
                                " " +
                                _vm._s(_vm.month)
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-card",
                            { staticClass: "neu-card mean-result col-lg-6" },
                            [
                              _c("h3", { staticClass: "subtitle-card" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("tests.work-environment.title")
                                    )
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                { staticClass: "h-100" },
                                [
                                  _c(
                                    "b-col",
                                    { staticClass: "my-auto" },
                                    [
                                      _c("gauge-chart", {
                                        attrs: {
                                          labels: [_vm.testName],
                                          result: _vm.DBResults.percentage
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { key: "dimensions", staticClass: "third" }, [
                        _c("h4", [_vm._v(_vm._s(_vm.$t("tests.dimensions")))]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-lg-12 results-container" },
                          _vm._l(_vm.DBResults.dimensions, function(d) {
                            return _c(
                              "div",
                              {
                                key: d.name,
                                staticClass: "col-lg-8 results-card"
                              },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-card",
                                      {
                                        directives: [
                                          {
                                            name: "b-toggle",
                                            rawName: "v-b-toggle",
                                            value: d.id,
                                            expression: "d.id"
                                          }
                                        ],
                                        staticClass: "neu-card",
                                        attrs: { title: _vm.$t(d.name) }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                d.result +
                                                  "/" +
                                                  d.totalDimensionPoints
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ])
                    ])
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ac8b7dc6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac8b7dc6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/selfEvaluationTests/WorkEnvironmentTest.vue
// module id = 3920
// module chunks = 130